
import { useNavigation } from '@react-navigation/native';
import { APIData } from '../constants';
import useRest from './base/useRest';

// CONTACTS

const preffix = "business-types";

export const useBusinessType = (options?: APIData) => {
    return useRest(`${preffix}/`, options);
};